module.exports = __webpack_public_path__ + "acd3fb786971cc9d3d7815ba3256f6c6.MP3";